import { createAsyncThunk } from "@reduxjs/toolkit";

import * as basketAPI from "../../../api/basket";
import * as signals from "../../../store/signals";
import { CSRF_HEADER, fetchJson, getCSRFToken } from "../../../utils/ajax";

/**
 * Freezes the assisted customer's basket, if they have one, so a CSR can
 * start a fresh order while the old cart stays on record.
 *
 * `onAfterStartNewBasket` carries whatever basket the server reports next,
 * which is `null` until something writes a new one.
 */
export const startNewBasket = createAsyncThunk(
    "csr/startNewBasket",
    async (): Promise<void> => {
        signals.csr.onBeforeStartNewBasket.emit();
        const basketOld = await basketAPI.load();
        if (basketOld) {
            await fetchJson(`/api/csr/baskets/${basketOld.id}/freeze/`, {
                method: "POST",
                headers: {
                    [CSRF_HEADER]: await getCSRFToken(),
                },
            });
        }
        const basketNew = basketOld ? await basketAPI.load() : null;
        signals.csr.onAfterStartNewBasket.emit(basketNew);
    },
);
